export default __webpack_public_path__ + "static/media/smartzee_logo.b0be398a.svg";